import { render } from "./SearchWithDeps.vue?vue&type=template&id=c719db22"
import script from "./SearchWithDeps.vue?vue&type=script&lang=js"
export * from "./SearchWithDeps.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__